import { render, staticRenderFns } from "./ConsultaLtv.vue?vue&type=template&id=4ccde2da&scoped=true"
import script from "./ConsultaLtv.vue?vue&type=script&lang=js"
export * from "./ConsultaLtv.vue?vue&type=script&lang=js"
import style0 from "./ConsultaLtv.vue?vue&type=style&index=0&id=4ccde2da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccde2da",
  null
  
)

export default component.exports